import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/utils/api'
import type { Team } from '@/types'

type Args = {
  name: string
  organizationId: string
}

export const useCreateTeam = () => {
  const queryClient = useQueryClient()

  return useMutation<Team, Error, Args>({
    mutationFn: async ({ name, organizationId }) => {
      const { data } = await api.post(
        `/organizations/${organizationId}/teams`,
        { name }
      )
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['org-teams'] })
    },
  })
}
